import { render, staticRenderFns } from "./Wells.vue?vue&type=template&id=90685eec"
import script from "./Wells.vue?vue&type=script&lang=js"
export * from "./Wells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports